// enforce the menu to recalculate after font file loads
document.fonts.ready
  .then(() => {
    if (
      document.querySelector('.col-nav nav')
      && document.querySelector('.col-nav nav').classList.contains('too-long')
    ) {
      return
    }

    setTimeout(navToolongHandler, 100)
  })

const navToolongHandler = e => {
  const enforce = e ? false : true

  const colNav = document.querySelector('.col-nav nav')

  if (!colNav) {
    return
  }

  if (enforce) {
    colNav.classList.remove('too-long')
  }

  const header = document.querySelector('#header')
  const btnCol = document.querySelector('#btn-mobile-menu-col')
  const headerContainer = document.querySelector('#header')
  const headerRowChildren = headerContainer.querySelectorAll('.header-main-row > div')
  const width = Array.from(headerRowChildren)
    .filter( o => !o.classList.contains('width-excluded'))
    .map( o => {
      if (enforce) {
        delete o.dataset.width
      }

      const w = 'width' in o.dataset === false || parseInt(o.dataset.width) == 0
        ? o.offsetWidth
        : parseInt(o.dataset.width)
      o.dataset.width = w
      return w
    })
    .reduce((a, b) => a + b)

  const tooLong = width > headerContainer.offsetWidth
  colNav.classList.toggle('too-long', tooLong)
  colNav.ariaHidden = tooLong ? 'true' : 'false'

  if (tooLong) {
    colNav.parentNode.classList.add('px-0')
    btnCol.classList.add('show')
  } else {
    colNav.parentNode.classList.remove('px-0')
    btnCol.classList.remove('show')
  }

  header.classList.remove('cloak')

  return tooLong
}

$(document).ready(function () {
  function Menu(menuEl) {
    this.menu = menuEl
    this.$menu = $(this.menu)
    this.$childMenu = this.$menu.find(".application-menu__menu")
    this.$childMenuCloseButton = this.$menu.find(".js-child-menu-close")
    this.$searchToggle = $(".search-toggle")
    this.$searchForm = $(".search-form")
    this.$searchInput = $("#SearchForm_SearchForm_q")
    this.bind()
  }

  Menu.prototype.bind = function () {
    // More custom events
    // - 'press.application-menu'
    // - 'unpress.application-menu'
    // - 'expand.application-menu'
    // - 'contract.application-menu'

    this.menu.addEventListener(
      "open.application-menu",
      function () {
        // trigger the open event globaly
        $(document).trigger("application-menu:change", ["open"])
        this.openChildMenu()
      }.bind(this)
    )

    this.menu.addEventListener(
      "close.application-menu",
      function () {
        // trigger the open event globaly
        $(document).trigger("application-menu:change", ["close"])
        this.closeChildMenu()
      }.bind(this)
    )

    this.$childMenuCloseButton.click(
      function () {
        this.onChildMenuClose()
      }.bind(this)
    )

    this.$searchToggle.off().on(
      "click",
      function (e) {
        e.preventDefault()
        e.stopPropagation()
        this.toggleSearch()
        if (this.$searchToggle.hasClass('search-toggle--on')) {
          this.$searchToggle.find('.icon-search').removeClass('mdi-magnify')
          this.$searchToggle.find('.icon-search').addClass('mdi-close')
          this.$searchToggle.addClass('current')
        } else {
          this.$searchToggle.find('.icon-search').addClass('mdi-magnify')
          this.$searchToggle.find('.icon-search').removeClass('mdi-close')
          this.$searchToggle.removeClass('current')
        }
      }.bind(this)
    )
  }

  Menu.prototype.onChildMenuClose = function () {
    this.closeChildMenu()
  }

  Menu.prototype.closeChildMenu = function () {
    this.menu.classList.remove("active")
    this.$childMenu.removeClass("expanded")
  }

  Menu.prototype.openChildMenu = function () {
    this.menu.classList.add("active")
    this.$childMenu.addClass("expanded")
  }

  Menu.prototype.isSearchActive = function () {
    return this.$searchToggle.hasClass("search-toggle--on")
  }

  Menu.prototype.openSearchForm = function () {
    this.$searchToggle.addClass("search-toggle--on")
    this.$searchForm.addClass("search-form--on")
    this.$searchInput.focus()
  }

  Menu.prototype.closeSearchForm = function () {
    this.$searchToggle.removeClass("search-toggle--on")
    this.$searchForm.removeClass("search-form--on")
    this.$searchInput.blur()
  }

  Menu.prototype.toggleSearch = function () {
    if (this.isSearchActive()) {
      this.closeSearchForm()
    } else {
      this.openSearchForm()
    }
  }

  window.SOMAR = window.SOMAR || {}
  if (!window.SOMAR.MainMenu) {
    window.SOMAR.MainMenus = []

    $(".application-menu").each(function () {
      window.SOMAR.MainMenus.push(new Menu(this))
    })
  }

  window.addEventListener('resize', navToolongHandler)
})

// Mobile Menu Toggler
$(document).ready(function () {
  function Toggler(buttonEl) {
    this.button = buttonEl
    this.$button = $(buttonEl)
    this.menu = document.querySelector(".js-navigation")
    this.$menu = $(this.menu)
    this.bind()
  }

  Toggler.prototype.bind = function () {
    this.button.addEventListener(
      "click",
      function (e) {
        this.onClick()
      }.bind(this)
    )
  }

  Toggler.prototype.onClick = function () {
    var isExpanded = this.$menu.hasClass("expand")
    if (isExpanded) {
      this.collapseMenu()
    } else {
      this.expandMenu()
    }
  }

  Toggler.prototype.expandMenu = function () {
    this.$menu.addClass("expand").attr("aria-expanded", "true")

    this.$button.attr("aria-pressed", "true")
  }

  Toggler.prototype.collapseMenu = function () {
    this.$menu.removeClass("expand").attr("aria-expanded", "false")

    this.$button.attr("aria-pressed", "false")
  }

  // --- new mobile menu
  const mousedownHandler = e => {
    if (
      !e.target.classList
      || (
        e.target.id !== 'btn-mobile-menu'
        && !e.target.closest('#btn-mobile-menu')
        && !e.target.closest('#site-nav')
        && !e.target.closest('.search-form')
      )
    ) {
      closeSiteNav()
    }
  }

  const siteHeader = document.querySelector('#header')
  const btnSiteNav = document.querySelector('#btn-mobile-menu')
  if (!btnSiteNav) {
    return
  }

  const siteNav = document.querySelector('#' + btnSiteNav.getAttribute('aria-controls'))

  const closeActiveSearch = () => {
    const activeSearchForm = document.querySelector('.search-form.search-form--on')
    const activeSearchToggler = document.querySelector('.search-toggle')

    if (activeSearchForm) {
      activeSearchForm.classList.remove('search-form--on')
    }

    if (activeSearchToggler) {
      activeSearchToggler.querySelector('.icon-search').classList.add('mdi-magnify')
      activeSearchToggler.querySelector('.icon-search').classList.remove('mdi-close')
      activeSearchToggler.classList.remove('search-toggle--on', 'current')
    }
  }

  const openSiteNav = () => {
    closeActiveSearch()
    window.removeEventListener('mousedown', mousedownHandler)

    btnSiteNav.ariaExpanded = 'true'
    siteNav.ariaHidden = 'false'

    siteHeader.classList.add('toggled')

    btnSiteNav
      .querySelector('.mdi')
      .classList
      .remove('mdi-menu')
    btnSiteNav
      .querySelector('.mdi')
      .classList
      .add('mdi-close')

    siteNav.classList.add('toggled')
    window.addEventListener('mousedown', mousedownHandler)
  }

  const closeSiteNav = () => {
    btnSiteNav.ariaExpanded = 'false'
    siteNav.ariaHidden = 'true'

    siteHeader.classList.remove('toggled')

    btnSiteNav
      .querySelector('.mdi')
      .classList
      .add('mdi-menu')
    btnSiteNav
      .querySelector('.mdi')
      .classList
      .remove('mdi-close')

    siteNav.classList.remove('toggled')
    window.removeEventListener('mousedown', mousedownHandler)
  }

  btnSiteNav.addEventListener('click', () => {
    if (btnSiteNav.ariaExpanded === 'false') {
      openSiteNav()
    } else {
      closeSiteNav()
    }
  })
})
